import { api } from "../../api";
import { handleResponse, RequestOptions } from "../types";
import { getCookie } from "../../helpers/utils";
import { cookieSupervision, cookieToken } from "../../constants";

const getOptions = () => {
  const authenticity_token = getCookie(cookieToken);
  const isSupervision = JSON.parse(getCookie(cookieSupervision));

  const endpoint = isSupervision
    ? api.supervision.subaffiliate_report_v2.options
    : api.affiliate.subaffiliate_report_v2.options;

  return fetch(
    `${endpoint}${authenticity_token ? `?authenticity_token=${authenticity_token}` : ''}`,
    {...RequestOptions('GET')}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getFiltersField = (data: { [key: string]: any; }) => {
  const authenticity_token = getCookie(cookieToken);
  const isSupervision = JSON.parse(getCookie(cookieSupervision));

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  };

  const mapping: { [key: string]: string } = {
    platformIds: "platforms",
    productIds: "products",
    players: "players",
    parentAffiliateIds: "parent-affiliates",
    referredAffiliateIds: "referred-affiliates",
    commissionLevels: "commission-levels",
    deals: "deals",
    brands: "brands",
    currencies: "currencies",
    geo: "geo",
  };

  //@ts-ignore
  const field = `${mapping[`${data.label}`]}`;

  const endpoint = isSupervision
    ? api.supervision.subaffiliate_report_v2.filters
    : api.affiliate.subaffiliate_report_v2.filters;

  return fetch(
    `${endpoint}/${field}`,
    {...RequestOptions('POST', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getReport = (data: any) => {
  const authenticity_token = getCookie(cookieToken);
  const isSupervision = JSON.parse(getCookie(cookieSupervision));

  const sendData = {
    ...data.payload,
    authenticity_token: authenticity_token,
  };

  const endpoint = isSupervision
    ? api.supervision.subaffiliate_report_v2.generate_report
    : api.affiliate.subaffiliate_report_v2.generate_report;

  return fetch(
    `${endpoint}`,
    {...RequestOptions('POST', JSON.stringify(sendData))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getColumns = () => {
  const authenticity_token = getCookie(cookieToken);
  const isSupervision = JSON.parse(getCookie(cookieSupervision));

  const endpoint = isSupervision
    ? api.supervision.subaffiliate_report_v2.columns
    : api.affiliate.subaffiliate_report_v2.columns;

  return fetch(
    `${endpoint}${authenticity_token ? `?authenticity_token=${authenticity_token}` : ''}`,
    {...RequestOptions('GET')}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const setDownload = (data: any) => {
  const authenticity_token = getCookie(cookieToken);
  const isSupervision = JSON.parse(getCookie(cookieSupervision));

  const payload = {
    ...data.payload,
    authenticity_token: authenticity_token,
  };

  const endpoint = isSupervision
    ? api.supervision.subaffiliate_report_v2.download
    : api.affiliate.subaffiliate_report_v2.download;

  return fetch(
    `${endpoint}`,
    {...RequestOptions('POST', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

export const subaffiliateReportV2Service = {
  getOptions,
  getFiltersField,
  getReport,
  getColumns,
  setDownload,
};
